/* eslint-disable @typescript-eslint/naming-convention */
import { memo } from 'react';
import {
    IntlProvider as BaseIntlProvider,
    IntlConfig as BaseIntlConfig,
    ReactIntlErrorCode,
} from 'react-intl';
import { DEFAULT_LANGUAGE } from '@utils/constants';
import fr from './lang/fr/messages.json';

const LOCALES = {
    fr,
};

const onError: BaseIntlConfig['onError'] = (error) => {
    if (
        error.code !== ReactIntlErrorCode.MISSING_TRANSLATION &&
        error.code !== ReactIntlErrorCode.MISSING_DATA
    ) {
        console.error(error);
    }
};

export type IntlProviderProps = {
    children: React.ReactNode;
};

const getNavigatorLanguage = (): string =>
    navigator?.languages?.length
        ? navigator.languages[0]
        : navigator.userLanguage ||
          navigator.language ||
          navigator.browserLanguage ||
          DEFAULT_LANGUAGE;

const getLocalePrefix = (locale: string): string =>
    locale.length !== 2 ? locale.slice(0, 2) : locale;

const IntlProvider = ({ children }: IntlProviderProps) => {
    const userLocale = getLocalePrefix(
        getNavigatorLanguage(),
    ) as keyof typeof LOCALES;
    return (
        <BaseIntlProvider
            locale={userLocale}
            messages={LOCALES[userLocale] || fr}
            onError={onError}
        >
            {children}
        </BaseIntlProvider>
    );
};

export default memo(IntlProvider);
